import React from 'react';
import { cssMap } from '@compiled/react';

import PageIcon from '@atlaskit/icon/core/page';
import { Anchor, Flex, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import type { Source } from './popularQuestionsTypes.ts';

type SourceCardProps = {
	source: Source;
};

export const SourceCard = ({ source }: SourceCardProps) => {
	const { title, url, iconUrl } = source;

	return (
		<Anchor href={url} css={styles.card} target="_blank" rel="noopener noreferrer">
			<div css={styles.iconWrapper}>
				{iconUrl ? (
					<img src={iconUrl} alt="" css={styles.sourceIcon} />
				) : (
					<PageIcon label="" color={token('color.icon.brand')} spacing="none" />
				)}
			</div>
			<Flex direction="column" gap="space.050">
				<div css={styles.title}>
					<Text size="small" weight="semibold" color="color.text.brand">
						{title}
					</Text>
				</div>
			</Flex>
		</Anchor>
	);
};

const styles = cssMap({
	card: {
		display: 'flex',
		alignItems: 'flex-start',
		gap: token('space.100'),
		paddingBlock: token('space.150'),
		paddingInline: token('space.150'),
		borderWidth: token('border.width'),
		borderStyle: 'solid',
		borderColor: token('color.border'),
		borderRadius: token('radius.small'),
		flex: '1 1 0',
		minWidth: '0',
		textDecoration: 'none',
		color: 'inherit',
		cursor: 'pointer',
		'&:hover': {
			backgroundColor: token('color.background.neutral.subtle.hovered'),
		},
	},
	iconWrapper: {
		width: '20px',
		height: '20px',
		flexShrink: 0,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	sourceIcon: {
		width: '16px',
		height: '16px',
		objectFit: 'contain',
	},
	title: {
		display: '-webkit-box',
		WebkitLineClamp: 1,
		WebkitBoxOrient: 'vertical',
		overflow: 'hidden',
	},
});
